const SvgLoader = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M43.6596 37.7658C46.2719 34.0352 47.7687 29.6383 47.9753 25.0887C48.1819 20.5391 47.0897 16.0247 44.8264 12.0726C42.563 8.12058 39.2219 4.89411 35.1933 2.77006C31.1647 0.646004 26.6148 -0.287941 22.0752 0.0773069L22.7681 8.68948C25.6735 8.45572 28.5854 9.05344 31.1637 10.4128C33.742 11.7722 35.8803 13.8372 37.3289 16.3665C38.7774 18.8958 39.4764 21.785 39.3442 24.6968C39.212 27.6085 38.254 30.4225 36.5822 32.8101L43.6596 37.7658Z"
      fill="url(#paint0_linear_960_4127)"
    />
    <path
      d="M43.6596 37.7658C41.7062 40.5556 39.1814 42.8977 36.253 44.6365C33.3246 46.3752 30.0597 47.4708 26.6753 47.8504C23.2908 48.2301 19.8643 47.885 16.6234 46.8383C13.3826 45.7915 10.4017 44.067 7.87871 41.7793C5.35575 39.4916 3.34858 36.6932 1.99056 33.57C0.632542 30.4468 -0.0452111 27.0703 0.00233938 23.6649C0.0498898 20.2596 0.821655 16.9033 2.26635 13.8192C3.71104 10.7351 5.79557 7.99383 8.38142 5.77749L14.0041 12.3376C12.3492 13.7561 11.0151 15.5105 10.0905 17.4843C9.16586 19.4581 8.67193 21.6061 8.6415 23.7855C8.61106 25.965 9.04483 28.1259 9.91396 30.1248C10.7831 32.1236 12.0677 33.9146 13.6824 35.3788C15.2971 36.8429 17.2049 37.9466 19.279 38.6165C21.3531 39.2864 23.5461 39.5072 25.7122 39.2643C27.8782 39.0213 29.9678 38.3201 31.8419 37.2073C33.7161 36.0945 35.332 34.5956 36.5822 32.8101L43.6596 37.7658Z"
      fill="#F0F4FF"
    />
    <path
      d="M43.6597 10.2342C40.3075 5.44685 35.3238 2.04717 29.6434 0.672938C23.963 -0.70129 17.9764 0.0443804 12.8067 2.77005C7.63702 5.49573 3.63952 10.0141 1.56419 15.4774C-0.511145 20.9408 -0.521676 26.9736 1.53457 32.4442L9.62212 29.4043C8.30613 25.9031 8.31287 22.0421 9.64108 18.5456C10.9693 15.049 13.5277 12.1573 16.8363 10.4128C20.1449 8.6684 23.9764 8.19117 27.6118 9.07068C31.2472 9.95019 34.4368 12.126 36.5822 15.1899L43.6597 10.2342Z"
      fill="url(#paint1_linear_960_4127)"
    />
    <path
      d="M0.0146203 23.1624C-0.126463 27.2025 0.755249 31.2127 2.57794 34.8211L10.2899 30.9255C9.12336 28.6162 8.55906 26.0496 8.64936 23.4639L0.0146203 23.1624Z"
      fill="url(#paint2_linear_960_4127)"
    />
    <defs>
      <linearGradient id="paint0_linear_960_4127" x1="45" y1="30" x2="41.5" y2="36.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#D3DDFF" />
        <stop offset="1" stopColor="#F0F4FF" />
      </linearGradient>
      <linearGradient id="paint1_linear_960_4127" x1="25" y1="7" x2="39.5" y2="13" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3763FF" />
        <stop offset="1" stopColor="#3763FF" stopOpacity="0" />
        <stop offset="1" stopColor="#D3DDFF" />
      </linearGradient>
      <linearGradient id="paint2_linear_960_4127" x1="5" y1="34" x2="5" y2="23.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#2525D7" />
        <stop offset="1" stopColor="#3763FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgLoader;
